module.exports = __webpack_public_path__ + "img/RandoBoy.5ef75827.png";